<span>
  <span ng-show="loading">
    <i class="fa fa-spinner fa-spin"></i>
  </span>
  <span ng-hide="loading || !responsaveis.length" ng-bind-html="joinedNames()"></span>
  <p ng-hide="loading || responsaveis.length" class="text-danger">
    <b>Atenção!!</b> Não existe nenhum usuário responsável por essa aprovação!
  </p>
</span>
